import type { AIProviderName } from './types';

export const DAILY_LIMITS: Record<AIProviderName, number> = {
  gemini: 550,
  claude: 30,
  openai: 50,
  groq: 12000,
  volcengine: 500,
};

const USAGE_KEY = 'linyuan.usage';

interface UsageRecord {
  date: string;
  gemini: number;
  claude: number;
  openai: number;
  groq: number;
  volcengine: number;
}

function todayKey(): string {
  // Local-midnight key, NOT UTC. The settings UI promises "resets at midnight (local)";
  // toISOString() would silently roll over at UTC midnight (08:00 in UTC+8).
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getUsage(): UsageRecord {
  try {
    const raw = JSON.parse(localStorage.getItem(USAGE_KEY) ?? '{}') as Partial<UsageRecord>;
    if (raw.date !== todayKey()) {
      return { date: todayKey(), gemini: 0, claude: 0, openai: 0, groq: 0, volcengine: 0 };
    }
    return {
      date: raw.date ?? todayKey(),
      gemini: (raw.gemini ?? 0) | 0,
      claude: (raw.claude ?? 0) | 0,
      openai: (raw.openai ?? 0) | 0,
      groq: (raw.groq ?? 0) | 0,
      volcengine: (raw.volcengine ?? 0) | 0,
    };
  } catch {
    return { date: todayKey(), gemini: 0, claude: 0, openai: 0, groq: 0, volcengine: 0 };
  }
}

export function recordUsage(provider: AIProviderName): void {
  const u = getUsage();
  u[provider] += 1;
  localStorage.setItem(USAGE_KEY, JSON.stringify(u));
}

export function isOverLimit(provider: AIProviderName): boolean {
  return getUsage()[provider] >= DAILY_LIMITS[provider];
}

export function getLimit(provider: AIProviderName): number {
  return DAILY_LIMITS[provider];
}
